import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setUserPoints, clearUserPoints } from "../ReduxSlices/PointsSlice";
import { apiGet } from "./functions/Api";

export const PointsWidget = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isConnected = useSelector((s) => s.auth.isConnected);
  const account = useSelector((s) => s.auth.account);
  const ethereum = useSelector((s) => s.auth.ethereum);
  const userPoints = useSelector((s) => s.points.userPoints);
  const [hover, setHover] = useState(false);
  const lastWallet = useRef(null);

  const wallet = ethereum || account;

  // Clear points when wallet changes or disconnects
  useEffect(() => {
    if (wallet !== lastWallet.current) {
      lastWallet.current = wallet;
      dispatch(clearUserPoints());
    }
  }, [wallet, dispatch]);

  // Fetch points for current wallet
  useEffect(() => {
    if (!wallet) return;
    const load = async () => {
      try {
        const r = await apiGet(`/points/user/${wallet}`);
        if (r?.success && r.data) dispatch(setUserPoints(r.data));
      } catch (_) {}
    };
    load();
  }, [wallet, dispatch]);

  if (!isConnected && !ethereum) return null;
  if (!userPoints) return null;

  const pts = userPoints?.totalPoints || 0;
  const rank = userPoints?.rank;

  return (
    <div
      onClick={() => navigate("/perps/leaderboard")}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="relative cursor-pointer select-none"
    >
      {/* A raised pill like every other control in the header — `--raise` on
          `--pillow-sm`, radius 999, and the 1px hover lift rather than the
          old 3px one. */}
      <div className="ce-pill flex items-center gap-[6px] px-[13px] py-[8px]">
        {/* Small diamond icon */}
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M6 1L10.5 6L6 11L1.5 6L6 1Z" fill="#5b1dee"/>
        </svg>
        <span className="text-[13px] font-semibold text-[#202020]">{pts.toLocaleString()}</span>
      </div>

      {hover && (
        <div className="ce-card absolute top-full mt-2 right-0 p-3 min-w-[150px] z-[9999] animate-fadeIn">
          <div className="text-[13px] font-bold text-[#202020] mb-1">{pts.toLocaleString()} pts</div>
          {rank && <div className="text-[12px] text-[#8A8A8A]">Rank #{rank}</div>}
          <div className="mt-2 pt-2 border-t border-[#f0f0f0]">
            <span className="text-[11px] text-[#5b1dee] font-medium">View Leaderboard →</span>
          </div>
        </div>
      )}
    </div>
  );
};
